<template>
  <div class="yinping_body">
    <div class="tupian">
      <img :src="tupian">
    </div>


    <van-collapse v-model="value">
      <van-collapse-item v-if="code==0" name="1" title="音频目录">
        <div v-for="(item,index) in yp" class="shiping">

          <!-- 加在yinpin的if        v-if="statuse==1 || item.ivs==1"-->
          <div class="yinpin">
            <aplayer
                :music="{
                       artist:'',
                       title: item.titles,
                       src: item.url,
                       pic: tupian
                       }"
            />
          </div>
        </div>
      </van-collapse-item>
      <van-collapse-item v-if="code==1" name="1" title="跟唱目录">
        <div v-for="(item,index) in gc" class="shiping">

          <!-- 加在yinpin的if        v-if="statuse==1 || item.ivs==1"-->
          <div class="yinpin">
            <aplayer
                :music="{
                       artist:'',
                       title: item.titles,
                       src: item.url,
                       pic: tupian
                       }"
            />
            <img id="close" alt="" src="@/assets/close.png" @click="dropGC(item.id)">
          </div>
        </div>
      </van-collapse-item>
      <van-collapse-item v-if="code==2" name="1" title="伴奏目录">
        <div v-for="(item,index) in bzlist" class="shiping">

          <!-- 加在yinpin的if        v-if="statuse==1 || item.ivs==1"-->
          <div class="yinpin">
            <aplayer
                :music="{
                       artist:'',
                       title: item.titles,
                       src: item.url,
                       pic: tupian
                       }"
            />
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>

    <!--    <div class="home">-->
    <!--      <h1 @click="handleclick()">开始录音</h1>-->
    <!--      <h1 @click="handleclickl()">继续录音</h1>-->
    <!--      <h1 @click="handleclickt()">结束录音</h1>-->
    <!--      <h1 @click="handleclickb()">录音播放</h1>-->
    <!--    </div>-->


  </div>
</template>

<script>
import Aplayer from 'vue-aplayer'

import Recorder from 'js-audio-recorder'
import {Dialog} from "vant";

var recorder = new Recorder()
export default {
  name: "bank",
  data() {
    return {
      code: '',//0 为音频文件 1为跟唱目录
      bzlist: [],
      activeName: 'a',
      value: ['1', '2', '3'],
      inputt: '',
      tupian: '',
      biaoti: '',
      laoshi: '',
      youxiaoqi: '',
      zhuangtai: '',
      jine: '',
      renshu: '',
      jieshao: '',
      neirong: '',
      listsp: [],
      urls: '',
      statuse: '',
      jieshu: '',
      playerOptions: {},
      times: '',
      yp: [],
      gc: {}
    }
  },
  created() {
    if (this.$route.query.code == 'yp') {
      this.code = 0;
    } else if (this.$route.query.code == 'gc') {
      this.code = 1;
    } else if (this.$route.query.code == 'bz') {
      this.code = 2;
    }

    console.log("code", this.code);
    this.getcity()

    //获取录音列表
    this.getData();


    console.log("播放页获取到的课程id:", this.$route.query.id);
  },

  methods: {
    dropGC(id) {
      let that = this;
      Dialog.confirm({

        message: '确认删除该跟唱吗？',
      }).then(() => {


        this.myrequest({
          url: '/client/deleteGenchang.action',
          types: 'get',
          data: {
            // token:this.$store.state.token,
            id
          },
          succ: (res) => {
            console.log("result:", res);

            //重新渲染跟唱列表
            that.getData();
          },
          errs: (msg) => {
            console.log(msg);
          }
        })
      });
    },
    getData() {


      this.myrequest({
        url: '/client/getcurriculuminfo.action',
        types: 'get',
        data: {
          // token:this.$store.state.token,
          id: this.$route.query.id
        },
        succ: (res) => {
          console.log("result:", res);
          this.bzlist = res.bzlist
          this.tupian = res.data.covermap
          this.biaoti = res.data.titles
          this.laoshi = res.data.teacher
          this.youxiaoqi = res.data.effectivetime
          this.zhuangtai = res.data.types
          this.jine = res.data.fee
          this.renshu = res.data.buynum
          this.jieshao = res.data.introduce
          this.neirong = res.data.content
          this.listsp = res.splist
          this.pjlists = res.pjlisr
          this.statuse = res.orderstatus
          this.yp = res.yplist
          this.yuanjia = res.data.price
          this.tp = res.imglist
          this.gc = res.mygclist
          this.givesize = res.givesize
        },
        errs: (msg) => {
          console.log(msg);
        }
      })
    },

    // handleclick () {
    //
    //     recorder.start()// 开始录音
    //     console.log(1)
    // },
    // handleclickl () {
    //
    //     recorder.resume()// 继续录音
    //     console.log(2)
    // },
    // handleclickt () {
    //     console.log(3)
    //     recorder.stop() // 结束录音
    // },
    // handleclickb () {
    //     console.log(4)
    //     recorder.play() // 录音播放
    // },
    getcity() {
      this.myrequest({
        url: '/client/getcurriculumdata.action',
        types: 'get',
        data: {
          // token:this.$store.state.token
          id: this.$route.query.id,
          types: 2
        },
        succ: (res) => {
          this.listsp = res.data
          this.urls = res.url
          this.statuse = res.orderstatus
          this.times = res.time
          this.yp = res.yplist
          this.tupian = res.covermap
        },
        errs: (msg) => {

        }
      })
    },
    //播放
    play(e) {
      console.log("play")
    },
    //暂停
    pause(e) {
      if (e.currentTime() != e.duration()) {
        this.myrequest({
          url: '/client/lookcurricumlums.action',
          types: 'post',
          data: {
            id: this.$route.query.id,
            time: e.currentTime()
          },
          succ: (res) => {

          },
          errs: (msg) => {

          }
        })
      }
      // console.log("pause",e.currentTime())
      // console.log("pause",e.duration())
    },
    //看完
    ended(e) {
      this.myrequest({
        url: '/client/lookcurricumlums.action',
        types: 'post',
        data: {
          id: this.$route.query.id
        },
        succ: (res) => {

        },
        errs: (msg) => {

        }
      })
      // console.log("ended")
    },
    shiping(item) {
      if (item.ivs == 1) {
        this.$router.push({path: '/bofang', query: {id: item.id}})
        this.getcity()
      } else if (this.statuse == 1) {
        this.$router.push({path: '/bofang', query: {id: item.id}})
        this.getcity()
      }
    },
  },
  components: {
    Aplayer,
  }
}
</script>

<style lang="stylus" scoped>
.yinping_body {
  width 100%;
  position relative
  /*position relative;*/

  .yinpin {
    /*position absolute*/
    /*top 0px;*/
    width 100%;
    position relative

    #close {
      width 10px;
      height 10px;
      position absolute;
      right 10px;
      top 10px;
    }
  }

  .video-js .vjs-big-play-button {
    margin-left 50%
  }

  .kechengxiangqing {
    width 95%;
    margin 10px auto;

    dl {
      width 100%

      dt {
        font-size 12pt
        font-weight 500
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      dd {
        margin-left 0
      }

      dd:nth-of-type(1) {
        font-size 9pt
        color #666
        line-height 200%
      }

      dd:nth-of-type(2) {
        font-size 13pt
        color #e9353e

        span {
          font-size 9pt
        }
      }

      dd:nth-of-type(3) {
        margin-top 5px
        color #888
        font-size 10pt
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
    }

    .biaoti {
      font-weight 500;
      font-size 16px;
      color #333333;
      margin-left 10px;
    }

    .laoshi {
      font-weight 500;
      font-size 14px;
      color #ccc;
      margin-left 5px;
      margin-top 10px;
    }

    .cputong {
      font-weight 500;
      font-size 14px;
      color #ccc;
      margin-left 5px;
      margin-top 5px;
    }

    .xianshi {
      /*margin-left 5px;*/

      .xianshiname {
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 5px;
      }

      .youxiao {
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 5px;
      }

      .xianjia {
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 5px;
      }

      .suzhi {
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 5px;
      }

      .jieshi {
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 5px;
      }
    }
  }

  .foot {
    width 95%;
    margin auto;
    display flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position fixed;
    bottom 0px;

    .shuru {
      width 85%;
    }

    .anniu {
      width 10%;
    }
  }

  .tupian {
    width 100%;
    max-height 100vw
    overflow hidden

    .video-player {
      width 100%

      >>> .video-js .vjs-big-play-button {
        width 20%
        margin-left 40%
        margin-top 15%
      }
    }

    img {
      width 100%;
      /*height 250px;*/
    }
  }

  .xiangqing {
    font-weight 500;
    font-size 16px;
    color #333333;
    width 90%;
    margin 10px auto;
  }

  .xi {
    width 90%;
    margin 10px auto;
    line-height 1.5
  }

  .xiangqingtu {
    width 90%;
    margin 0px auto;

    img {
      width 100%;
      display block
    }
  }

  .shiping {
    position relative;
    margin-top 10px;


    >>> .van-collapse-item__content {
      padding 0px;
    }
    width 90%;
    margin 10px auto;
    display flex;

    .xiabiao {
      margin-right 10px;
    }

    .kecheng {

    }

    .bofang {
      position absolute;
      right 0px;

      img {
        width 20px;
        height 20px;
      }
    }
  }

  .pinglun {
    width 90%;
    margin 10px auto;
    display flex

    .touxiang {
      /*margin-top 10px;*/

      img {
        width 30px;
        height 30px;
        border-radius 30px;
      }
    }

    .neirong {
      margin-left 10px;

      .name {
        color #333333;
        font-size 14px;
        line-height 30px
        font-weight 500
      }

      .ping {
        margin-top 0px;
        color #444;
      }

      .shijian {
        /*margin-top 5px;*/
        color #ccc;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ziyuanku/yinpin.vue